import React from 'react';

import { DeleteAccountSection } from '@/components/DeleteAccountSection';
import { PlexTracReporting } from '@/components/reporting/PlexTracReporting';
import { useWhoami } from '@/hooks/useWhoami';
import { ChariotModulesOptions } from '@/sections/settings/components';
import { cn } from '@/utils/classname';

interface PraetorianSettingsContentProps {
  customerEmail?: string;
  isPraetorianUser: boolean;
  isLoadingFlags: boolean;
  flags: string[];
  setFlags?: React.Dispatch<React.SetStateAction<string[]>>;
  updateFlags?: (params: {
    flagsToAdd?: string[];
    flagsToDelete?: string[];
    successMessage?: string;
    showToast?: boolean;
  }) => Promise<unknown>;
  prevFlags?: string[];
  onDeleteAccount?: () => void;
  showDeleteAccount?: boolean;
  showPlexTrac?: boolean;
  className?: string;
}

export const PraetorianSettingsContent: React.FC<
  PraetorianSettingsContentProps
> = ({
  customerEmail,
  isPraetorianUser,
  isLoadingFlags,
  flags,
  setFlags,
  updateFlags,
  prevFlags,
  onDeleteAccount,
  showDeleteAccount = true,
  showPlexTrac = true,
  className,
}) => {
  const { hasEntitlement } = useWhoami();

  return (
    <div className={cn('p-6', className)}>
      {/* Advanced Features Section */}
      <div className="mt-2 mb-4">
        <h3 className="text-chariot-text-primary text-base font-bold">
          Advanced Features
        </h3>
        <p className="text-chariot-text-secondary text-sm">
          Premium capabilities available based on your subscription and
          requirements.
        </p>
      </div>
      <ChariotModulesOptions
        isLoadingFlags={isLoadingFlags}
        flags={flags}
        setFlags={setFlags}
        readOnly={!isPraetorianUser || !hasEntitlement('manage_settings')}
        updateFlags={updateFlags}
        prevFlags={prevFlags}
      />

      {/* PlexTrac Reporting Section - Now integrated in Praetorian Only Settings */}
      {showPlexTrac && (
        <div className="mt-6">
          <PlexTracReporting
            customerEmail={customerEmail}
            isPraetorianUser={isPraetorianUser}
            showTitle={false}
          />
        </div>
      )}

      {/* Account Management Section - Only show if enabled */}
      {showDeleteAccount && onDeleteAccount && (
        <DeleteAccountSection
          onDeleteAccount={onDeleteAccount}
          isPraetorianUser={isPraetorianUser}
          className="mt-6"
        />
      )}
    </div>
  );
};
